export default __webpack_public_path__ + "assets/calendar-9a7adb681cec0f6e59c709e454abe3e4.svg";